<template>
	<div class="c-detail">
		<div v-if="title" class="c-detail-title">{{title}}</div>
		<div class="c-detail-content flex-wrap">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: String
		},
		
		data() {
			return {
			}
		}
	}
</script>

<style lang="stylus">
	@import './style/index'
</style>
